"use client";

import React from "react";

interface EditIconProps {
	size?: number;
	className?: string;
}

const EditIcon: React.FC<EditIconProps> = ({ size = 20, className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 20 20"
		fill="none"
		className={className ?? "text-[var(--colors-neutral-950,#040404)]"}
	>
		<path
			d="M10 2.50214H4.16667C3.72464 2.50214 3.30072 2.67774 2.98816 2.9903C2.67559 3.30286 2.5 3.72678 2.5 4.16881V15.8355C2.5 16.2775 2.67559 16.7014 2.98816 17.014C3.30072 17.3265 3.72464 17.5021 4.16667 17.5021H15.8333C16.2754 17.5021 16.6993 17.3265 17.0118 17.014C17.3244 16.7014 17.5 16.2775 17.5 15.8355V10.0021M15.3125 2.18964C15.644 1.85812 16.0937 1.67188 16.5625 1.67188C17.0313 1.67188 17.481 1.85812 17.8125 2.18964C18.144 2.52116 18.3303 2.9708 18.3303 3.43964C18.3303 3.90848 18.144 4.35812 17.8125 4.68964L10.3017 12.2013C10.1038 12.399 9.85934 12.5437 9.59083 12.6221L7.19667 13.3221C7.12496 13.3431 7.04895 13.3443 6.97659 13.3258C6.90423 13.3072 6.83819 13.2696 6.78537 13.2168C6.73255 13.164 6.69491 13.0979 6.67637 13.0256C6.65783 12.9532 6.65909 12.8772 6.68 12.8055L7.38 10.4113C7.45877 10.143 7.60378 9.89886 7.80167 9.70131L15.3125 2.18964Z"
			stroke="currentColor"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default EditIcon;
